class BbParserServiceImpl {

  private mapper: any = {
    '<': '&lt;',
    '>': '&gt;',
    '\\[list\\]': '<ul>',
    '\\[\\*\\]': '<li>',
    '\\[\/list\\]': '</ul>',
    '\\[img\\]': '<img style="margin-left:10px;margin-right:10px;max-width:550px;" src="',
    '\\[\/img\\]': '">',
    '\\[img \\[align\\]': '<img align="',
    '\\[\/align\\]\\[width\\]': '" style="margin-left:10px;margin-right:10px;max-width:',
    '\\[\/width\\]\\]': 'px;" src="',
    '\\[img \\[width\\]': '<img style="margin-left:10px;margin-right:10px;max-width:',
    '\\[\/width\\]\\[align\\]': 'px;" align="',
    '\\[\/align\\]\\]': '" src="',
    '\\[b\\]': '<b>',
    '\\[\/b\\]': '</b>',
    '\\[u\\]': '<u>',
    '\\[\/u\\]': '</u>',
    '\\[i\\]': '<i>',
    '\\[\/i\\]': '</i>',
    '\\[color="': '<span style="color:',
    '\\[\/color\\]': '</span>',
    '\\[size="': '<span style="font-size:',
    '\\[\/size\\]': '</span>',
    // tslint:disable-next-line:max-line-length
    '\\[url="': '<a style="color:black;" onMouseOver="this.style.textDecoration=\'none\'" onMouseOut="this.style.textDecoration=\'underline\'" target=\'_blank\' href="',
    // tslint:disable-next-line:max-line-length
    '\\[url=\\\\"': '<a style="color:black;" onMouseOver="this.style.textDecoration=\'none\'" onMouseOut="this.style.textDecoration=\'underline\'" target=\'_blank\' href="',
    '\\[\/url\\]': '</a>',
    '\\[mail="': '<a href="mailto:',
    '\\[\/mail\\]': '</a>',
    '\\[code\\]': '<code>',
    '\\[\/code\\]': '</code>',
    '\\[quote\\]': '<table width=100% bgcolor=lightgray><tr><td bgcolor=white>',
    '\\[\/quote\\]': '</td></tr></table>',
    '\\[list="': '<ol start="',
    '\\[s\\]': '<strike>',
    '\\[\/s\\]': '</strike>',
    '\\[bg="': '<span style="background-color:',
    '\\[\/bg\\]': '</span>',
    '\\[hr\\]': '<hr>',
    '\\[table="': '<table style="',
    '\\[table\\]': '<table>',
    '\\[\/table\\]': '</table>',
    '\\[tr="': '<tr style="',
    '\\[tr\\]': '<tr>',
    '\\[\/tr\\]': '</tr>',
    '\\[td="': '<td style="',
    '\\[td\\]': '<td>',
    '\\[\/td\\]': '</td>',
    '\\[youtube\\]': '<iframe width="560" height="315" src="',
    '\\[\/youtube\\]': '" frameborder="0" allowfullscreen></iframe>',
    '\\[grouptitle id="': '<span class="grouptitle ',
    '\\[\/grouptitle\\]': '</span>',
    '\\[group id="': '<div class="group ',
    '\\[\/group\\]': '</div>',
    '\\]': '>',
    '\\r\\n': '<br>',
    '\\n': '<br>',
  };

  public fromBb(bbcode: string) {
    const keys = Object.keys(this.mapper);
    bbcode = bbcode.replace(new RegExp('\\\\"', 'g'), '"');
    bbcode = this.sanitizeTable(bbcode);
    keys.forEach(key => {
      bbcode = bbcode.replace(new RegExp('(' + key + ')', 'g'), this.mapper[key]);
    });
    return bbcode;
  }

  /**
   * Removes every new line character in the table
   * @param text 
   */
  private sanitizeTable(text: string) {
    const starter = /\[table/g;
    const ender = /\[\/table/g;
    let match;
    // tslint:disable-next-line:no-conditional-assignment
    while((match = starter.exec(text)) != null) {
      const end = ender.exec(text);
      if (end !== null) {
        text = this.replaceAllBetween(match.index, end.index, text, new RegExp('\\r\\n', 'g'), '');
      }
    }
    return text;
  }

  private replaceAllBetween(start: number, end: number, text: string, regex: RegExp, toWhat: string) {
    const between = text.substring(start, end).replace(regex, toWhat);
    return text.substring(0, start) + between + text.substring(end);
};
}

const BbParserService = new BbParserServiceImpl();

export default BbParserService;
export { BbParserServiceImpl };
